/**
 * Agent Conversations Page
 * 
 * Full conversation management interface for agents.
 * Uses the same ProfessionalConversationView as company owners
 * but filtered to show only conversations assigned to this agent.
 */

import React from 'react'
import { ProfessionalConversationView } from '../../components/features/chat/professional/ProfessionalConversationView'
import { useAuth } from '../../hooks/useAuth'
import { useRealTimeNotifications } from '../../hooks/useRealTimeNotifications'
import { logger } from '../../utils/logger'

export const AgentConversations: React.FC = () => {
  const { user } = useAuth()
  
  // Real-time connection status (same as ConversationManagement)
  const {
    isConnected: isRealTimeConnected,
    connectionState,
    lastUpdate: realTimeLastUpdate
  } = useRealTimeNotifications()

  React.useEffect(() => {
    logger.info('🎯 Agent Conversations page loaded', {
      component: 'AgentConversations',
      userId: user?.id,
      userType: user?.user_type,
      realTimeConnected: isRealTimeConnected,
      connectionState
    })
  }, [user, isRealTimeConnected, connectionState])

  return (
    <div className="h-full">
      <ProfessionalConversationView
        className="h-full"
        isRealTimeConnected={isRealTimeConnected}
        realTimeConnectionState={connectionState}
        lastRealTimeUpdate={realTimeLastUpdate}
        debugMode={process.env.NODE_ENV === 'development'}
      />
    </div>
  )
}

export default AgentConversations